import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { RiTextSpacing } from 'react-icons/ri';

// Function to format the date
const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

const BirthdayCarousel = ({ birthdays }) => {
  const birthday = 'https://res.cloudinary.com/dlhfcdscf/image/upload/v1735118607/public/birthday_baoy6r.png';
  const [currentBirthdayIndex, setCurrentBirthdayIndex] = useState(0);
  const [activeBirthday, setActiveBirthday] = useState(null);

  useEffect(() => {
    if (birthdays && birthdays.length > 0) {
      // Set the active birthday based on the current index
      setActiveBirthday(birthdays[currentBirthdayIndex]);
      
      if (birthdays.length > 1) {
        const interval = setInterval(() => {
          setCurrentBirthdayIndex(
            (prevIndex) => (prevIndex + 1) % birthdays.length
          );
        }, 10000); // Change every 10 seconds

        return () => clearInterval(interval);
      }
    }
  }, [birthdays, currentBirthdayIndex]);

  // Check if the active birthday is valid
  useEffect(() => {
    if (activeBirthday) {
      const birthdayDate = new Date(activeBirthday.messageDetails.birthdayDate);
      const today = new Date();
      // Adjusted comparison to ensure it only checks for dates strictly in the past
      if (
        birthdayDate <
        new Date(today.getFullYear(), today.getMonth(), today.getDate())
      ) {
        setCurrentBirthdayIndex(null);
      }
    }
  }, [activeBirthday]);

  // Do not display if no birthdays are active or past the date
  if (!activeBirthday) return null;

  // Inline styles
  const styles = {
    container: {
      border: '2px solid white',
      width: '100%',
      height: '90%',
      marginTop: '20px',
      display: 'flex',
      marginLeft: '10px',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      backgroundImage: `url(${birthday})`,
      backgroundSize: 'cover',
      color: 'white',
      BackgroundPosition: 'top',
      borderRadius: '20px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    },
    heading: {
      marginTop: '40px',
      // marginBottom: '14px',
      fontSize: '24px',
      fontWeight: 'bold',
      textShadow: `
      -1px -1px 0 #000,  
       1px -1px 0 #000,
      -1px  1px 0 #000,
       1px  1px 0 #000
    `,
    },
    greeting: {
      marginTop: '25px',
      width: '60%',
      fontSize: '20px',
      RiTextSpacing: '2px',
      textShadow: `
      -1px -1px 0 #000,  
       1px -1px 0 #000,
      -1px  1px 0 #000,
       1px  1px 0 #000
    `,
    },
    date: {
      fontSize: '16px',
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>
        {activeBirthday.messageDetails.celebratorName}
      </h2>
      <p style={styles.greeting}>{activeBirthday.messageDetails.greeting}</p>
    </div>
  );
};

BirthdayCarousel.propTypes = {
  birthdays: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      author: PropTypes.string.isRequired,
      messageType: PropTypes.string.isRequired,
      buildingId: PropTypes.string.isRequired,
      messageDetails: PropTypes.shape({
        celebratorName: PropTypes.string.isRequired,
        greeting: PropTypes.string.isRequired,
        birthdayDate: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
};

export default BirthdayCarousel;
